import { ScrollArea } from '@mantine/core';
import { getQueryValue } from '@zorro/common-utils';
import { Modal } from '@zorro/design-system/v2/Modal';
import { Box } from '@zorro/web/design-system';
import { FlowIdProvider, useAppRouter } from '@zorro/web/ui-utils';

import { EnrollmentConfirmation } from '../EnrollmentConfirmation';

type Props = {
  onboardingPeriodId: string;
  employerId: string;
  employeeId: string;
  onClose: () => void;
  isOpen: boolean;
};

export const EnrollmentConfirmationModal = ({
  onboardingPeriodId,
  employerId,
  employeeId,
  onClose,
  isOpen,
}: Props) => {
  const { router, navigateToRoute } = useAppRouter();
  const benefitId = getQueryValue(router.query.benefitId);

  const handleClose = () => {
    onClose();
    navigateToRoute(
      'OPS_EMPLOYEE_PLANS_TAB',
      [{ employerId, employeeId, onboardingPeriodId }],
      {},
      false,
      false
    );
  };

  return (
    <Modal
      onClose={handleClose}
      isOpen={isOpen}
      size="83rem"
      shouldCloseOnClickOutside={false}
      shouldCloseOnEscape={false}
    >
      <ScrollArea
        styles={{ viewport: { overflowX: 'hidden' } }}
        h="calc(100vh - 14rem)"
        offsetScrollbars="y"
        type="never"
      >
        <FlowIdProvider isOpen={isOpen}>
          <EnrollmentConfirmation
            employerId={employerId}
            employeeId={employeeId}
            onboardingPeriodId={onboardingPeriodId}
            benefitId={benefitId}
            onClose={handleClose}
          />
        </FlowIdProvider>
      </ScrollArea>
      <Box
        id="enrollment-confirmation-modal-footer"
        m="0 -2.5rem -1rem -1.75rem"
      />
    </Modal>
  );
};
